import React from "react";
import { Divider, Tabs } from "antd";
import { Link } from "react-router-dom";

import config from "@/config";
import { JobByCompanyCard } from "@/pages/job/detailJob/components/JobDescription/JobByCompanyCard";
import { JobListCard } from "@/pages/job/detailJob/components/JobDescription/JobListCard";

export const JobDescription = ({ job, jobs, jobByCompany, handleClick }) => {

    return (
        <div className="lg:w-2/3 w-full lg:min-h-full  bg-white p-6 rounded-lg shadow">
            <div className={""}>
                <h2 className="text-xl font-bold mb-4">Chi tiết tin tuyển dụng</h2>
                <Divider
                    style={{
                        borderColor: '#7cb305',
                    }} />

                {job.Description && job.JobDescription && (
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold">Mô tả công việc</h3>
                        <ul className="list-disc space-y-2 pl-6 text-gray-600">
                            {job.Description && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.Description}</div>` }}></li>
                            )}
                            {job.JobDescription && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.JobDescription}</div>` }}></li>
                            )}
                        </ul>
                    </div >
                )}

                {job.RequestAge && job.RequestJob && job.RequestLevel && job.RequestProfile && (

                    <div className="mb-6">
                        <h3 className="text-lg font-semibold">Yêu cầu ứng viên</h3>
                        <ul className="list-disc pl-6 text-gray-600">
                            {job.RequestAge && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.RequestAge}</div>` }}></li>
                            )}
                            {job.RequestJob && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.RequestJob}</div>` }}></li>
                            )}
                            {job.RequestLevel && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.RequestLevel}</div>` }}></li>
                            )}
                            {job.RequestProfile && (
                                <li dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${job.RequestProfile}</div>` }}></li>
                            )}
                        </ul>
                    </div>
                )}
                {job.JobSalary && (
                    <div>
                        <h3 className="text-lg font-semibold">Thu nhập</h3>
                        <div dangerouslySetInnerHTML={{ __html: `<div class="!text-black font-normal">${config.webConfig.getCurrency(job.JobSalary)}</div>` }}></div>
                    </div>
                )}
            </div >
            <div className={"Other-jobs"}>
                <h2 className="text-xl font-bold mb-4 mt-6">Công việc liên quan khác</h2>
                <Divider
                    style={{
                        borderColor: '#7cb305',
                    }} />
                <Tabs
                    defaultActiveKey="1"
                    centered
                    items={[
                        {
                            key: '1',
                            label: 'Công việc chung nghề nghiệp',
                            children: (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {jobs.filter((jobItem) => jobItem.Pk !== job.Pk).map((jobItem, index) => (
                                        <JobListCard
                                            key={jobItem.Pk} // cần thêm key
                                            data={jobItem}
                                            index={index}
                                            handleClick={handleClick}
                                        />
                                    ))}
                                    <Link
                                        to={config.routes.job}
                                        className="text-green-600 flex col-span-full justify-center items-center text-center font-bold text-lg hover:underline"
                                    >
                                        Xem thêm công việc khác <i className="ml-3 fa-solid fa-arrow-up-right-from-square" />
                                    </Link>
                                </div>
                            ),
                        },
                        {
                            key: '2',
                            label: 'Công việc chung công ty',
                            children: (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {jobByCompany.filter((jobItem) => jobItem.Pk !== job.Pk).map((jobItem, index) => (
                                        <JobByCompanyCard
                                            key={jobItem.Pk} // cũng nên thêm key ở đây
                                            data={jobItem}
                                            index={index}
                                            handleClick={handleClick}
                                        />
                                    ))}
                                    <Link
                                        to={config.routes.job}
                                        className="text-green-600 flex col-span-full justify-center items-center text-center font-bold text-lg hover:underline"
                                    >
                                        Xem thêm công việc khác <i className="ml-3 fa-solid fa-arrow-up-right-from-square" />
                                    </Link>
                                </div>
                            ),
                        },
                    ]}
                />

            </div>
        </div >
    )
}